export default __webpack_public_path__ + "static/media/9-min.9c0f85e7.jpg";